import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


class FileInputArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drag: false,
    };
    this.dropRef = React.createRef();
    this.uploadHiddenInput = React.createRef();
    this.handleDragIn = this.handleDragIn.bind(this);
    this.handleDragOut = this.handleDragOut.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
  }

  handleUploadImage(file) {
    const { acceptTypes, maxFileSize, onSuccess, onInvalidFileSize, onInvalidFileType } = this.props;

    if (file) {
      const fileTypeIsValid = acceptTypes.indexOf(file.type) !== -1;
      const fileSizeIsValid = !maxFileSize || file.size <= maxFileSize;

      // Attach file with valid extension and size
      if (fileTypeIsValid && fileSizeIsValid) {
        let reader = new FileReader();
        let data = null;
        reader.addEventListener('load', () => {
          data = reader.result;

          if (onSuccess) {
            onSuccess(data);
          }
        });
        reader.readAsDataURL(file);
      }

      // File extension error
      else if (!fileTypeIsValid) {
        if (onInvalidFileType) {
          onInvalidFileType();
        }
      }

      // File size error
      else if (!fileSizeIsValid) {
        if (onInvalidFileSize) {
          onInvalidFileSize();
        }
      }
    }
  }

  handleClick() {
    const { isDisabled } = this.props;
    if (!isDisabled) {
      this.uploadHiddenInput.current.click();
    }
  }

  handleChangeHiddenInput(event) {
    const { isDisabled } = this.props;
    const file = event.target.files[0];
    if (!isDisabled) {
      this.handleUploadImage(file);
    }
  }

  handleDrag(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.isDisabled) {
      return null;
    }
    if (!this.state.drag) {
      this.setState({ drag: true });
    }
  }

  handleDragIn(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.isDisabled) {
      return null;
    }
    this.setState({ drag: false });
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
      if (this.props.handleDragIn) {
        this.props.handleDragIn();
      }
    }
  }

  handleDragOut(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.isDisabled) {
      return null;
    }
    this.setState({ drag: false });
    if (this.props.handleDragOut) {
      this.props.handleDragOut();
    }
  }

  handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.isDisabled) {
      return null;
    }
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length === 1) {
      this.handleUploadImage(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
      if (this.props.handleDrop) {
        this.props.handleDrop();
      }
    }
  }

  componentDidMount() {
    let dropZone = this.dropRef.current;
    dropZone.addEventListener('dragenter', this.handleDragIn);
    dropZone.addEventListener('dragleave', this.handleDragOut);
    dropZone.addEventListener('dragover', this.handleDrag);
    dropZone.addEventListener('drop', this.handleDrop);
  }

  componentWillUnmount() {
    let dropZone = this.dropRef.current;
    dropZone.removeEventListener('dragenter', this.handleDragIn);
    dropZone.removeEventListener('dragleave', this.handleDragOut);
    dropZone.removeEventListener('dragover', this.handleDrag);
    dropZone.removeEventListener('drop', this.handleDrop);
  }

  render() {
    const { caption, extraClassName, children, hiddenCaption, isDisabled, acceptTypes } = this.props;
    const { drag } = this.state;

    return (
      <div
        ref={this.dropRef}
        onClick={() => this.handleClick()}
        className={classNames(styles.fileInputArea, extraClassName, 'jest-file-input-area')}>
        <input
          ref={this.uploadHiddenInput}
          accept={acceptTypes.join(',')}
          type="file"
          className={classNames(styles.hiddenFileInput, 'jest-hidden-file-input-area')}
          onChange={(event) => this.handleChangeHiddenInput(event)} />
        <div className={classNames(
          {
            [styles.bookshelfHeaderBorderContainer]: true,
            isDrag: drag,
            [styles.isDisabled]: isDisabled,
          })}>
          <div className={classNames(styles.dashedBorder, { isDrag: drag, isDisabled })} ref={this.dropRef}>
            <div className={styles.topCorners} />
            {(caption && !hiddenCaption && !isDisabled) && (
              <div className={classNames(styles.caption, { isDrag: drag })}>
                <div className={styles.uploadIcon} />
                <span>{caption}</span>
              </div>
            )}
            <div className={styles.bottomCorners} />
          </div>
        </div>
        {children}
      </div>
    );
  }
};

FileInputArea.propTypes = {
  handleDrop: PropTypes.func,
  handleDragIn: PropTypes.func,
  handleDragOut: PropTypes.func,
  handleDrag: PropTypes.func,
  onInvalidFileSize: PropTypes.func,
  onInvalidFileType: PropTypes.func,
  onSuccess: PropTypes.func,
  acceptTypes: PropTypes.arrayOf(PropTypes.string),
  maxFileSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  isDisabled: PropTypes.bool,
  caption: PropTypes.string,
  hiddenCaption: PropTypes.bool,
  extraClassName: PropTypes.string,
};

FileInputArea.defaultProps = {
  isDisabled: false,
  hiddenCaption: false,
  acceptTypes: [],
  extraClassName: '',
};

export default FileInputArea;
